import React from "react";
import ImagenLogin from "../../../components/ImagenLogin";
import Registro from "./Registro";
import { Box } from "@mui/material";

const MenuRegistro = () => {
    return(
        <Box Box sx={{
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'column', md: 'row-reverse' }, 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            width: '100%', 
            minHeight: '100vh', 
        }}>
            <ImagenLogin />
            <Registro />
        </Box>
    );
}

export default MenuRegistro;